export default "__VITE_ASSET__DS0Kz5aE__"